import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { PasswordResetActions } from 'Redux/modules/passwordReset/actions';
import { PasswordResetSelectors } from 'Redux/modules/passwordReset/selectors';
import AppConfig from 'Config/AppConfig';
import AuthFooter from '../../../Components/AuthFooter/AuthFooter';
import PiplLogo from '../../../../../static/img/pipl_logo.svg';
import styles from './PasswordReset.module.less';

const CONTACT_EMAIL = 'support@pipl.com';

// Ported from accounts/templates/pages/password_reset/password_reset_sent.html
// Shows "check your email" confirmation; includes a RESEND button that re-submits
// the same email + a fresh captcha token.
function ResetSent({ email }) {
  const dispatch = useDispatch();
  const isSubmitting = useSelector(PasswordResetSelectors.passwordResetIsSubmittingSelector);
  const [captchaToken, setCaptchaToken] = React.useState(null);
  const [resent, setResent] = React.useState(false);

  const handleResend = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setResent(true);
    dispatch(PasswordResetActions.requestReset({ email, captcha: captchaToken }));
  };

  return (
    <>
      <div className={styles['center-form']}>
        <a href="https://pipl.com">
          <img className={`center-block ${styles.logo}`} src={PiplLogo} width="120" height="75" alt="Pipl" />
        </a>

        <div className={styles['form-header']}>
          <h1 className={styles['h-title']}>Password Reset</h1>
        </div>

        {!resent ? (
          <div>
            <p>
              Password reset email was sent, you should receive it momentarily.
              <br />
              If you do not receive it within a few minutes, try resending or contact us at{' '}
              <a className={styles['contact-link']} href={`mailto:${CONTACT_EMAIL}`}>
                {CONTACT_EMAIL}
              </a>
              .
            </p>
            <br />
            <form onSubmit={handleResend}>
              <div className={styles.captcha}>
                <ReCAPTCHA
                  sitekey={AppConfig.RECAPTCHA_KEY || (window.__CONFIG__ && window.__CONFIG__.RECAPTCHA_KEY) || ''}
                  onChange={(token) => setCaptchaToken(token)}
                />
              </div>
              <button type="submit" name="resend" className={styles['btn-resend']} disabled={isSubmitting}>
                RESEND
              </button>
            </form>
          </div>
        ) : (
          <p>
            We have resent the password email.
            <br />
            If you do not receive it within a few minutes, contact us at{' '}
            <a className={styles['contact-link']} href={`mailto:${CONTACT_EMAIL}`}>
              {CONTACT_EMAIL}
            </a>
            .
          </p>
        )}
      </div>
      <AuthFooter />
    </>
  );
}

export default ResetSent;
